import { DOMAINS, REALMS, SITES, LOCALES } from '../gen/lang.js';

const isBitiba = (domain) => {
    return /(bitiba)/.test(domain);
};
const toUnderscoreLocale = (locale) => {
    const [lang, country] = locale.split('-');
    return `${lang}_${country.toUpperCase()}`;
};
const isSupportedDomain = (domain) => {
    return DOMAINS.includes(domain);
};
const isSupportedRealm = (realm) => {
    return REALMS.includes(realm);
};
const findSiteByDomain = (domain) => {
    return SITES.find((site) => site.domain === domain);
};
const findSiteById = (siteId) => {
    return SITES.find((site) => site.id === siteId);
};
const findSiteByLocale = (realm, locale) => {
    return SITES.find((site) => {
        return (site.realm === realm &&
            (site.locale === locale || !!site.alternateLocales.find((alt) => alt.locale === locale)));
    });
};
const isSupportedLocale = (locale, siteId) => {
    if (!siteId) {
        return LOCALES.includes(locale);
    }
    const site = findSiteById(siteId);
    return site.locale === locale || site.alternateLocales.some((alt) => alt.locale === locale);
};
const isSupportedLanguage = (site, language) => {
    return (site.language === language || site.alternateLocales.some((alt) => alt.language === language));
};
const getLanguageFromLocale = (locale) => {
    return locale.substring(0, locale.indexOf('-'));
};
const getCountryFromLocale = (locale) => {
    return locale.substring(locale.indexOf('-') + 1);
};
const getLocaleFromLanguage = (site, language) => {
    return site.language === language
        ? site.locale
        : site.alternateLocales.find((alt) => alt.language === language)?.locale;
};
const getLanguage = (site, locale) => {
    const language = site.locale === locale
        ? site.language
        : site.alternateLocales.find((altLocale) => altLocale.locale === locale)?.language;
    if (!language) {
        throw new Error(`Unsupported locale ${locale} for site ${site.id}.`);
    }
    return language;
};

export { findSiteByDomain, findSiteById, findSiteByLocale, getCountryFromLocale, getLanguage, getLanguageFromLocale, getLocaleFromLanguage, isBitiba, isSupportedDomain, isSupportedLanguage, isSupportedLocale, isSupportedRealm, toUnderscoreLocale };
//# sourceMappingURL=langService.js.map
